import { Box, Card, CardContent, Typography, Chip } from '@mui/material';
import { Place, EventAvailable, StorefrontOutlined } from '@mui/icons-material';
import moment from 'moment';
import PropTypes from 'prop-types';

export default function InfoRetailCard({ profile }) {
  if (!profile) return null;

  const venue = profile.venue || {};

  return (
    <Card sx={{ borderRadius: 2, boxShadow: 2, bgcolor: '#FFF5F2' }}>
      <CardContent>
        <Box display="flex" alignItems="center" gap={2} mb={1}>
          <StorefrontOutlined sx={{ fontSize: 32, color: '#EE7B57' }} />
          <Typography variant="h6" fontWeight="bold" color="#333">
            {venue.name || 'Retail Space Opportunity'}
          </Typography>
        </Box>

        {venue.address && (
          <Box display="flex" alignItems="center" gap={0.5} mb={1}>
            <Place sx={{ fontSize: 16, color: '#666' }} />
            <Typography variant="body2" color="text.secondary">
              {venue.address}
            </Typography>
          </Box>
        )}

        {(profile.start_date || profile.end_date) && (
          <Box display="flex" alignItems="center" gap={0.5}>
            <EventAvailable sx={{ fontSize: 16, color: '#EE7B57' }} />
            <Typography variant="body2" color="text.secondary">
              {profile.start_date ? moment(profile.start_date).format('MMM DD, YYYY') : 'Open'} -{' '}
              {profile.end_date ? moment(profile.end_date).format('MMM DD, YYYY') : 'Ongoing'}
            </Typography>
          </Box>
        )}

        {profile.status && (
          <Box mt={1}>
            <Chip
              label={profile.status}
              size="small"
              sx={{
                bgcolor: profile.status === 'active' ? '#3c99ba' : '#CCC',
                color: 'white',
                textTransform: 'capitalize',
              }}
            />
          </Box>
        )}
      </CardContent>
    </Card>
  );
}

InfoRetailCard.propTypes = {
  profile: PropTypes.shape({
    venue: PropTypes.shape({
      name: PropTypes.string,
      address: PropTypes.string,
    }),
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    status: PropTypes.string,
  }),
};

InfoRetailCard.defaultProps = {
  profile: null,
};
